import { render, staticRenderFns } from "./FactorialMaterialImportModal.vue?vue&type=template&id=4235239a&scoped=true"
import script from "./FactorialMaterialImportModal.vue?vue&type=script&lang=js"
export * from "./FactorialMaterialImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235239a",
  null
  
)

export default component.exports